import { render, staticRenderFns } from "./gambarModal.vue?vue&type=template&id=65d51704&scoped=true"
import script from "./gambarModal.vue?vue&type=script&lang=js"
export * from "./gambarModal.vue?vue&type=script&lang=js"
import style0 from "./gambarModal.vue?vue&type=style&index=0&id=65d51704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d51704",
  null
  
)

export default component.exports